import { Component, Host, h, Prop, getAssetPath } from '@stencil/core';

@Component({
  tag: 'afs-asset',
  styleUrl: 'afs-asset.css',
  shadow: true,
  assetsDirs: ['assets'],
})
export class AfsAsset {

  @Prop() href : string;
  @Prop() src : string;
  @Prop() alt : string;
  @Prop() fit : string = 'cover';
  @Prop() position : string = 'center';
  @Prop() ratioFit : boolean = false;

  render() {
    return <Host>
      <afs-image
        href={this.href} 
        src={getAssetPath(`./assets/${this.src}`)}
        alt={this.alt}
        fit={this.fit}
        position={this.position}
        ratio-fit={this.ratioFit}
      ></afs-image>
    </Host>
  }

}
